var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2491 12.269C21.5467 10.2822 20.0329 9.21391 17.9646 8.50107L18.6357 5.80899L16.9977 5.40138L16.3436 8.02237C15.9133 7.91431 15.4715 7.81383 15.0308 7.71335L15.6896 5.0753L14.0516 4.66675L13.3804 7.35788C13.024 7.27636 12.6733 7.19674 12.3339 7.11143L12.3358 7.10289L10.076 6.53888L9.63995 8.28874C9.63995 8.28874 10.8561 8.56743 10.8305 8.58449C11.4941 8.75037 11.6135 9.18926 11.5936 9.53809L10.8296 12.6046C10.8751 12.616 10.9339 12.633 11.0002 12.6586L10.8267 12.616L9.75559 16.9119C9.67407 17.1129 9.46838 17.4153 9.0039 17.3006C9.02096 17.3243 7.81331 17.0039 7.81331 17.0039L7 18.8789L9.13281 19.4107C9.52904 19.5102 9.91769 19.6145 10.2997 19.7121L9.62194 22.4345L11.259 22.8421L11.9301 20.15C12.3775 20.2704 12.8117 20.3823 13.2363 20.4884L12.5671 23.1691L14.2051 23.5767L14.8829 20.86C17.6773 21.389 19.7779 21.1757 20.6623 18.6485C21.3752 16.6143 20.6273 15.4398 19.157 14.6749C20.2282 14.4284 21.0339 13.7241 21.2491 12.269ZM17.5048 17.5186C16.9996 19.5538 13.5729 18.4533 12.4619 18.1774L13.3624 14.5706C14.4734 14.8483 18.0347 15.3972 17.5048 17.5186ZM18.0119 12.2397C17.5503 14.0909 14.699 13.1497 13.7748 12.9193L14.59 9.649C15.5142 9.87934 18.4935 10.3088 18.0119 12.2397Z",
    fill: "#ABABAB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.187bbb3d609c82db36db78749f2443c0.svg";
export { ForwardRef as ReactComponent };